var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-info"},[_c('b-icon',{attrs:{"icon":"info-circle-fill"}}),_c('div',[_vm._v("Metroliikenteessä on häiriöitä. Lisätietoa hetken kuluttua.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }